module.exports = "<p>לאחר שמצאתם את האזור שמעניין אתכם על המפה, בחרו בלחצן העיפרון שבחלקה הימני העליון של המפה. החזיקו את הלחצן השמאלי של העכבר לחוץ בזמן שאתם מקיפים את המקום שמעניין אתכם. עכשיו תוכלו לראות את הנכסים שנמצאים באזור שמעניין אתכם בלבד, ותצוגת המפה תותאם לאזור שבחרתם. כדי לבטל את הסימון ולראות שוב את כל הנכסים על המפה- פשוט הקישו על לחצן האיקס שבצידה הימני העליון של המפה.</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/translations/help/he/8.md
// module id = 821
// module chunks = 0